export const ls_save = (key, value) => {
    if (value === null) {
        localStorage.removeItem(key);
        return;
    }

    localStorage.setItem(key, JSON.stringify(value));
};

export const ls_read = (key) => {
    try {
        return JSON.parse(localStorage.getItem(key));
    } catch (e) {
        return null;
    }
};

export function getLocalStorageCurrentIdentity() {
    return ls_read('_currentIdentity');
}

export function setLocalStorageCurrentIdentity(identityOrNull) {
    ls_save('_currentIdentity', identityOrNull);
}

export function getLocalStorageCurrentProjectId() {
    return ls_read('_currentProjectId');
}

export function setLocalStorageCurrentProjectId(projectIdOrNull) {
    ls_save('_currentProjectId', projectIdOrNull);
}

export function getLocalStorageCurrentProjectName() {
    return ls_read('_currentProjectName');
}

export function setLocalStorageCurrentProjectName(projectNameOrNull) {
    ls_save('_currentProjectName', projectNameOrNull);
}